<template>
  <div class="page">
    <p style="font-size:11pt; line-height:115%; margin:0pt 0pt 10pt; text-align:center"><a
        name="_055-1599121612466"></a><span style="font-size:11pt">&#xa0;</span></p>
    <p style=" margin:0pt 0pt 20pt; text-align:center"><a name="_788-1601185948581"></a><span
        style="font-size:24pt; font-weight:bold">&#xa0;</span><span
        style="color:#3a4049; font-size:24pt; font-weight:bold">统一链接平台开发者协议</span>
    </p>
    <p style="font-size:11pt; line-height:115%; margin:0pt 0pt 10pt"><a name="_670-1607072676412"></a><span
        style="font-size:11pt">&#xa0;</span></p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_070-1607072663685"></a><span
        style="color:#595959; font-size:12pt">
        欢迎您使用统一链接平台，为保障您的合法权益，请您于注册使用本平台产品和服务之前，仔细阅读本协议以下全文。以下条款是您与玩咖欢聚（定义见下）订立的具备法律效力的协议（以下简称为“本协议”）。您注册时点击同意签署本协议或使用本平台向您提供的产品和服务即视为您对本协议条款的充分理解和完全接受。如果您不同意本协议条款，请您停止使用本平台向您提供的产品和服务。<b>其中，免除或者限制责任条款等重要内容将以加粗、标亮等形式提示您注意，您应重点阅读并理解。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_699-1607072663690"></a><span
        style="color:#000; font-size:14pt"><b>1、定义</b></span>
    </p>
       <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_699-1607072663690"></a><span
        style="color:#595959; font-size:12pt">1.1&emsp;&emsp;开发者：指有效申请并经平台审核同意后，在平台上申请统一链接等服务的产品主体，包括法人、其他组织或自然人。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_227-1607072663694"></a><span
        style="color:#595959; font-size:12pt">1.2&emsp;&emsp;欢聚-统一链接平台/统一链接平台：是为开发者提供统一链接的服务平台，由【玩咖欢聚科技（北京）有限公司】（以下简称“玩咖欢聚”），对该平台进行统一的管理、运营、技术支持等服务。除非特别标明，统一链接平台上的所有产品信息均为开发者提供，玩咖欢聚不对此向用户、权利人等相关方做出任何承诺与保证。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_490-1607072663698"></a><span
        style="color:#595959; font-size:12pt">1.3&emsp;&emsp;产品：指由开发者开发或享有相关权利及授权，在统一链接平台填写信息的，用以向用户提供各类服务或内容的应用程序软件、数字内容等，包括但不限于应用软件、游戏软件、工具类软件、在线服务类软件、主题、壁纸、字体、锁屏图片、视频内容、音乐内容、阅读内容、智能家居平台插件包等。特别指出，“产品”是基于协议定义的需要拟定的称呼，并非《产品质量责任法》等相关法律法规所规定的产品。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_510-1607072663702"></a><span
        style="color:#595959; font-size:12pt">1.4&emsp;&emsp;用户：指所有使用开发者接入统一链接服务的产品的使用者</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_960-1607072663708"></a><span
        style="color:#595959; font-size:12pt">1.5&emsp;&emsp;行为数据：指经过数据脱敏，不具体指向或不可识别用户、开发者身份的行为数据，包括用户和开发者发生在统一链接平台上的行为数据。/或综合分析。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_095-1607072663712"></a><span
        style="color:#595959; font-size:12pt">1.6&emsp;&emsp;个人信息：指以电子或其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。/明示同意，开发者不得将收集的数据用于其他任何使用目的或披露给任何第三方。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_317-1607072663718"></a><span
        style="color:#595959; font-size:12pt">1.7&emsp;&emsp;明示同意：指用户通过书面声明或主动做出肯定性动作，对其个人信息进行特定处理做出明确授权的行为。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_986-1607072663724"></a><span
        style="color:#000; font-size:14pt"><b>2、统一链接平台账号</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_024-1607072663729"></a><span
        style="color:#595959; font-size:12pt">2.1&emsp;&emsp;开发者在统一链接平台注册账号，提供信息的行为将受到本协议内容之约束。如开发者不同意本协议任何内容的，开发者不应在统一链接平台上填写任何信息。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_157-1607072663735"></a><span
        style="color:#595959; font-size:12pt">2.2&emsp;&emsp;如果开发者为自然人，应保证其已达法定年龄且具有完全之民事行为能力；如果开发者为法人、合伙企业或者其他组织，开发者应保证其实体是根据所在地之法律有效成立且存续。开发者声明并保证其加入统一链接平台的行为已经得到权利人的合法有效授权。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">2.3&emsp;&emsp;为确保您能够使用本服务，您应按照平台要求提供您的相关信息，包括但不限于公司注册信息、银行账户信息、税务信息、增值税登记号及联系人信息</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">2.4&emsp;&emsp;开发者应当妥善保管其平台账号和密码，通过开发者账号完成的行为均视为开发者本人完成。开发者有权随时更改密码，若开发者发现或合理怀疑其账号存在安全风险或被非法使用，开发者应当立即通知平台。未经平台书面同意，开发者账号不得许可或转让给第三方使用，不得作为财产分割或继承，本协议终止后，平台有权收回或注销开发者账号。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#000; font-size:14pt"><b>3、开发者的权利和义务</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">3.1&emsp;&emsp;开发者有权向平台申请统一链接等产品服务。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>3.2&emsp;&emsp;未经玩咖欢聚书面同意或平台功能所允许，开发者不得就其申请的产品服务向用户收取任何费用。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>3.3&emsp;&emsp;开发者产品应当符合统一链接平台不时发布的审核相关规范、指南或要求。开发者同意：其提供的产品先经平台审核并同意后，方可获得相关统一链接；获得链接后，平台有权但无义务定期或不定期对该链接进行核查。且上述核查过程中，玩咖欢聚有完全的权利依据审核相关规范独立判断是否单方终止该链接服务，包括在不通知开发者的情况下，对已经生成并运行的链接进行终止、屏蔽等处理措施。同时为了保障用户的使用体验，开发者不得利用链接进行违法违规事项，如出现相关违法违规情况的，玩咖欢聚有权利随时终止链接服务。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>3.4&emsp;&emsp;开发者应保证其产品内容应当符合法律规定，开发者对其产品和其统一链接的使用负全部责任：</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">1)&emsp;&emsp;开发者产品相关的所有信息、内容如程序、简介、名称、图片等开发者的任何内容、行为，不得违反相关法律、法规、政策的规定及本协议的约定；不得涉及有损国家安全和利益的信息；也不得涉及任何反动、色情、迷信、赌博、诽谤他人、虚假宣传等违法信息或其他违反公序良俗的内容；且不会侵犯任何人的合法权益，包括但不限于侵犯他人知识产权、名誉权、肖像权、隐私权、商业秘密等。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">2)&emsp;&emsp;开发者进一步保证，需要有法律法规规定的相关资质，特殊行业需要遵守相关管理规定及要求，尤其在有关医学医疗、金融、生理卫生、婚姻家庭、人体艺术和与此相关的自然、社会科学信息内容时，须对信息、内容进行严格审核，符合法律要求且内容健康，来源合法、可靠、有事实依据。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">3.5&emsp;&emsp;开发者同意，基于友好合作关系，在任何情形下开发者应维护统一链接平台的良好形象，不做任何负面、不实的评论、言论。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>3.6&emsp;&emsp;开发者违反本条款义务应当承担以下责任：</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>1)若开发者违反上述义务，玩咖欢聚均有权根据自己的判断随时采取删除相关信息、冻结开发者账号、终止产品的统一链接及后续的推广。对于玩咖欢聚根据自己的判断采取的前述各种措施，开发者同意无异议，若因此造成开发者或用户损失的，由开发者独立自行承担，且平台不对此承担任何责任。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>2)给玩咖欢聚及关联公司或合作方造成损失的，应当赔偿玩咖欢聚及其关联公司或合作方因此遭受的一切经济损失，若因开发者违反本协议承诺给玩咖欢聚及其关联公司或合作方造成不良影响，开发者应当授权玩咖欢聚及其关联公司或合作方对相关情况予以公开澄清。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>3)同时，开发者有义务及时采取其他合理措施防止损失进一步扩大。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#000; font-size:14pt"><b>4、平台的权利与义务</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">4.1&emsp;&emsp;玩咖欢聚有权审查开发者是否具备合法的经营资格，有权针对市场的需求、产品的质量、合法性和安全性对产品进行审核，玩咖欢聚有权依据其自身判断决定是否同意该产品运行统一链接。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>4.2&emsp;&emsp;如发生下列任一情形，玩咖欢聚有权以其认为合理的程度和普通人的知识水平做出独立判断和处理，包括但不限于删除或终止产品链接的运行、终止或暂停向开发者提供全部或部分服务、随时终止本协议：</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">1)&emsp;&emsp;涉嫌侵害第三人知识产权或其他权利等违反相关法律法规的规定；</span>
    </p>
     <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">2)&emsp;&emsp;违反合作方应用审核相关规范及其他规定；</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">3)&emsp;&emsp;内容包含色情、低俗、具有不良影响的内容；</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">4)&emsp;&emsp;存在不正当竞争等行为；</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5)&emsp;&emsp;内容包含病毒或被认定为恶意软件、间谍软件；</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">6)&emsp;&emsp;存在不可抗力、意外事件如网络故障导致产品无法上线；</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">7)&emsp;&emsp;玩咖欢聚独立判断产品已无发布、运营之必要；</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">8)&emsp;&emsp;存在其他不良影响或风险。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>4.3&emsp;&emsp;开发者同意并理解：玩咖欢聚仅向开发者提供统一链接的服务，是中立的服务提供者，产品由开发者自主开发、独立运营，开发者应依法进行产品的运营活动，因用户使用产品产生的任何问题、责任等，由开发者单独向用户负责并承担责任，与玩咖欢聚无关。玩咖欢聚为维护平台秩序及保障用户权益有权但无义务向开发者提供纠纷解决意见和建议。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>4.4&emsp;&emsp;开发者同意并理解，基于正当、合理、必要性的理由，玩咖欢聚有权知悉开发者产品使用统一链接时用户的数据，如发现数据中存在任何问题或怀疑，有权要求开发者改正，或者直接作出删除、屏蔽、终止链接等处理。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#000; font-size:14pt"><b>5、开发者个人信息保护义务</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.1&emsp;&emsp;开发者同意，其产品收集个人信息应遵守最小必要原则，调用最小范围内的权限，调用仅为实现本业务需求的功能。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.2&emsp;&emsp;为了满足《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》及个人信息保护相关配套措施的规定，开发者涉及处理用户个人信息的，应设有隐私政策或以其他方式明示告知用户拟收集的个人信息和使用方式、目的及必要性等，并获得用户同意（针对个人信息）或者明示同意（针对个人敏感信息）之后予以采集和处理，以保障用户的知情权。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.3&emsp;&emsp;若开发者产品涉及调用敏感接口（包括但不限于拨打电话、短信、彩信、WLAN、蜂窝网络连接、NFC、通讯录、通话记录、位置、录音录像等）、信息通知与推送、广告营销等功能时，均应有明显提示，并经过用户的主动同意和确认，同时提供具体的撤回管理选项。玩咖欢聚有权采取技术手段保留用户对上述业务和功能主动同意和确认的记录，以便法律规定要求时必要调取。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.4&emsp;&emsp;开发者对收集的数据予以分开存储，并在独立的计算机集群中进行处理。除非获得用户（若涉及用户个人信息）和玩咖欢聚的书面同意，开发者不得将收集的数据与开发者其他来源数据进行任何形式的汇聚和/或综合分析。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.5&emsp;&emsp;开发者应仅基于实现产品服务之目的而使用采集的数据，未经玩咖欢聚和用户（若涉及到用户个人信息）书面/明示同意，开发者不得将收集的数据用于其他任何使用目的或披露给任何第三方。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.6&emsp;&emsp;开发者同意，对采集数据及数据的处理行为的合法性、正当性和必要性承担法律责任，保证数据的采集、使用、分享符合《网络安全法》、《信息安全技术个人信息安全规范》等现行生效的相关法律、行政法规、国家标准的要求。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.7&emsp;&emsp;开发者同意，在终止产品服务后或在相关法规规定的保存期限结束后对收集的个人信息予以删除或匿名化处理。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.8&emsp;&emsp;开发者同意，对于发现或用户投诉开发者存在非法处理数据的情形，玩咖欢聚有权立即下架开发者的产品、断开链接，并要求开发者应及时响应采取补救措施予以解决，对玩咖欢聚及用户造成的损失，开发者应予以赔偿。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.9&emsp;&emsp;开发者承诺：其产品不含有病毒、木马等恶意代码或功能，不存在窃取用户个人信息、远程控制用户终端、恶意扣费、恶意传播、破坏用户终端系统、欺诈诱骗、流氓行为等恶意行为；不会利用系统漏洞，实现提升应用权限、执行恶意代码、获取用户数据等恶意行为。</span>
    </p>
     <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.10&emsp;&emsp;开发者承诺：数据原则上在中华人民共和国大陆境内处理。如涉及数据跨境的，应当不违背现行生效法律法规规定，并按照具体要求完成流程备案或审核，并签署具体的授权文件或协议。</span>
    </p>
     <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
      style="color:#595959; font-size:12pt">5.8&emsp;&emsp;开发者同意，对于发现或用户投诉开发者存在非法处理数据的情形，玩咖欢聚有权立即下架开发者的产品、断开链接，并要求开发者应及时响应采取补救措施予以解决，对玩咖欢聚及用户造成的损失，开发者应予以赔偿。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#000; font-size:14pt"><b>6、损害赔偿</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>6.1&emsp;&emsp;开发者若违反本协议或可适用的相关法律法规，导致玩咖欢聚及关联公司或合作方因此受到损害的，开发者应承担损害赔偿责任。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#000; font-size:14pt"><b>7、修改和解释</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt"><b>7.1&emsp;&emsp;玩咖欢聚保留随时修改、新增、删除本协议条款的权利。修改、新增、删除本协议条款时，玩咖欢聚将于官方网站公告修改、新增、删除的事实，而不另行对开发者进行个别通知。若开发者不同意修改、新增、删除的内容，可立即停止玩咖欢聚提供的服务。若开发者决定继续使用玩咖欢聚提供的服务，则视为同意，且不得因此而要求任何补偿或赔偿。</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#000; font-size:14pt"><b>8、其他约定</b></span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">8.1&emsp;&emsp;本协议的订立、效力、解释、履行及争议解决适用中华人民共和国法律。如果本协议的任何内容与法律相抵触，应以法律规定为准。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">8.2&emsp;&emsp;本协议的任何条款部分或全部无效的，不影响其它条款的效力。</span>
    </p>
    <p style="font-size:12pt; line-height:167%; margin:0pt 0pt 10pt"><a name="_665-1607072663749"></a><span
        style="color:#595959; font-size:12pt">8.3&emsp;&emsp;就本协议产生的争议及纠纷，开发者与玩咖欢聚应友好协商解决。协商不成的，任何一方有权向北京市朝阳区人民法院提起诉讼。</span>
    </p>
  </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">

.page {
  padding: 2% 3% 2% 6%;
  h3 {
    font-size: 13px;
    margin-top: 16px;
    margin-bottom: 10px;
  }
  p {
    font-size: 13px;
    width: 100%;
    font-weight: 300;
    color: #333333;
    line-height: 30px;
  }
}
table{
  td{
    padding: 10pt;
  }
}
</style>
